<template>
  <div>
    <van-sticky>
      <div class="beijingse" v-if="!show"></div>
      <img
        src="../../assets/img/wdl.png"
        class="img"
        width="100%"
        v-if="!token && isHaveRight == 0 && show"
        @click="log"
      />
      <img
        src="../../assets/img/wqx.png"
        class="img"
        width="100%"
        v-if="token && isHaveRight == 0 && show"
      />
      <video-player
        v-if="isHaveRight == 1 && show"
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @ready="playerReadied"
        @timeupdate="onPlayerTimeupdate($event)"
        @ended="onPlayerEnded($event)"
        @play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"
      ></video-player>
      <!-- <video-player
        v-if="isHaveRight==1"
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @ended="onPlayerEnded($event)"
        @play="onPlayerPlay($event)"
      >
      </video-player> -->
      <!-- <div style="    position: absolute;top: 0%;"><img src="../../assets/img/ming.png" width="100%"/></div> -->
      <van-row class="pin weihsu">
        <van-col span="8">
          <span class="feihuis">
            <img src="../../assets/img/gr.png" width="15px"/>{{ userName }}
          </span>
        </van-col>
        <van-col span="8">
          <!-- <span class="feihuis">
            {{
              lessonZannum > 10000 ? lessonZannum / 10000 + "万" : lessonZannum
            }}次点赞
          </span> -->
        </van-col>
        <van-col span="8">
          <!-- <span class="feihuis"
            >{{
              courseViewnum > 10000
                ? courseViewnum / 10000 + "万"
                : courseViewnum
            }}
            次播放
          </span> -->
        </van-col>
      </van-row>
      <div class="pin"
           style="background-color: #fff; margin-top: 10px;padding-bottom: 7px;    border-bottom: 1px solid #eee;">
        <span
          @click="onClick(2)"
          class="yansex mohjui"
          :class="name == 2 ? 'dazitis' : ''"
          v-if="commentsIsOpen==1"
        >讨论</span
        >
        <span
          @click="onClick(3)"
          class="yansex mohjui"
          :class="name == 3 ? 'dazitis' : ''"
          v-if="spectatorIsOpen==1"
        >观众</span
        >
        <span
          @click="onClick(0)"
          class="yansex mohjui"
          :class="name == 0 ? 'dazitis' : ''"
        >详情</span
        >
        <span
          v-if="lessonVos.length > 0"
          @click="onClick(1)"
          class="yansex mohjui"
          :class="name == 1 ? 'dazitis' : ''"
        >目录</span
        >
        <span
          v-if="resList && resList.length > 0"
          @click="onClick(4)"
          class="yansex mohjui"
          :class="name == 4 ? 'dazitis' : ''">
          课件
        </span>
      </div>
    </van-sticky>
    <div class="pin" style="background-color: #fff; margin:0 0 10px 0">
      <div style="background-color: #fff; margin:0 0 10px 0">
        <div
          v-if="name == 0"
          class="yuehussdfd"
          v-html="netClassCourseVo.courseInfo"
        ></div>
        <div v-if="name == 1" class="yuehussdfd">
          <div
            v-for="(list, index) in lessonVos"
            :key="index"
            :class="lessonId == list.lessonId ? 'sehuang' : 'huisedi'"
            @click="dianbo(list.lessonId)"
          >
            <div>
              {{ index + 1 }}
              <span class="miuyuif1">{{ list.lessonName }}</span
              ><img
              v-if="lessonId == list.lessonId"
              class="xiaoimg"
              src="../../assets/img/z.png"
              width="15px"
            />
              <div
                v-if="list.lessonLimit == 1 && list.isHaveRight == 1"
                class="kanshijuf"
              >
                试看
              </div>
              <div
                v-if="list.lessonLimit == 0 && list.isHaveRight == 0"
                class="kanshijuf1"
              >
                授权观看
              </div>
            </div>
            <div class="hui">{{ list.lessonViewnum }}次播放</div>
          </div>
        </div>
        <div v-if="name == 2&&commentsIsOpen==1" style="padding-bottom: 40px">
          <van-cell v-for="(item, index) in itemLists" :key="index" id="page">
            <div>
              <img
                v-if="item.headPhotoUrl && item.headPhotoUrl !== null"
                :src="item.headPhotoUrl"
                style="vertical-align: text-top"
                class="imghuif"
              /><img
              v-else
              src="../../assets/img/motouxiang.png"
              style="vertical-align: text-top"
              class="imghuif"
            /><span class="cohuis">{{ item.userName }}</span>
              <span class="feihuis rlji">
                <span class="shanchus" @click="shanchu(item)">删除</span>
                <span>未精选</span>
              </span>
            </div>
            <div class="mahjufas">{{ item.feelingContent }}</div>
          </van-cell>
          <div class="jkfkasfasf" v-if="itemLists.length > 0">
            ——以上评论被精选后，可被所有人看到——
          </div>
          <van-list

            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="10"
          >
            <van-cell v-for="(item, index) in itemList" :key="index">
              <div>
                <img
                  v-if="item.headPhotoUrl && item.headPhotoUrl !== null"
                  :src="item.headPhotoUrl"
                  style="vertical-align: text-top"
                  class="imghuif"
                /><img
                v-else
                src="../../assets/img/motouxiang.png"
                style="vertical-align: text-top"
                class="imghuif"
              /><span class="cohuis">{{ item.userName }}</span
              ><span class="feihuis rlji">
                  <img src="../../assets/img/xin.png" v-if="shifouzai(item.likeList)==0" style="vertical-align: middle"
                       width="15px" @click="lessonfeelingzan(item.feelingId,index)"/>
                  <img src="../../assets/img/hxin.png" v-else style="vertical-align: middle" width="15px"
                       @click="lessonfeelingcancelZan(item.feelingId,index)"/>
                  {{
                  item.likeList.length > 10000
                    ? item.likeList.length / 10000 + "万"
                    : item.likeList.length
                }}
                </span>
              </div>
              <div class="mahjufas">{{ item.feelingContent }}</div>
            </van-cell>
          </van-list>
          <div class="dibus">
            <div class="hjuisfg">
              <van-cell-group v-if="token && isHaveRight == 1 && shows">
                <div class="hjuisgagd" @click="buildBoard">
                  评论被精选后，可被所有人看到
                </div>
                <span
                  class="hjuisga"
                  style="margin-top: -30px; margin-right: 20px"
                >
                  <img src="../../assets/img/fayan.png" width="20px"/>
                </span>
              </van-cell-group>
              <van-cell-group v-if="!token">
                <div class="hjuisgagd">
                  登录后一起参与互动发言吧
                  <span style="margin-right: -20px" class="hjuisga jinru" @click="log">登录</span>
                </div>
              </van-cell-group>
              <van-cell-group v-if="token &&isHaveRight==0">
                <div class="hjuisgagd">
                  暂时没有权限，请联系管理员！
                </div>
              </van-cell-group>
            </div>
          </div>
        </div>
        <div v-if="name == 3&&spectatorIsOpen==1" style="padding-bottom: 40px;">
          <van-list
            id="page"
            v-model="loadings"
            :finished="finisheds"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoads"
            :offset="10"
          >
            <van-cell v-for="(item,index) in guanlist" :key="index">
              <div>
                <img
                  v-if="item.headPhotoUrl&&item.headPhotoUrl!==null"
                  :src="item.headPhotoUrl"
                  style="vertical-align: middle"
                  class="imghuif"
                /><img
                v-else
                src="../../assets/img/motouxiang.png"
                style="vertical-align: middle"
                class="imghuif"
              /><span class="cohuis">{{ item.viewersName }}
                  <span class="cohuis">（{{ item.schoolName }}）</span>
                </span
                >
              </div>
            </van-cell>
          </van-list>
          <div class="jkfkasfasf" v-if="guanlist.length == 0">
            暂时没有观众观看
          </div>
        </div>
        <div v-if="name == 4" style="padding-bottom: 40px;">
          <van-row
            gutter="10"
            class="mag"
            v-for="(list, index) in resList"
            :key="index"
          >
            <van-col span="4" class="famous-teacher-studio-img-row">
              <img
                :src="list.serverHttp + 'Icon/' + list.fileFormat + '.png'"
                width="100%"
                style="width: auto; max-height: 40px; border-radius: 5px;"
              />
            </van-col>
            <van-col span="20">
              <van-col span="24" style="max-width: 100%;">
                <wx-open-launch-weapp
                  appid="wx8fb5fc6abd9a9ebb"
                  :path="list.fileUrl"
                >
                  <script type="text/wxtag-template">
                    <div
                      style="font-size: 14px !important;font-weight: bold; display: inline-block; float: left; margin-right: 10px;">
                      {{ list.fileName }}
                    </div>
                  </script>
                </wx-open-launch-weapp>
              </van-col>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <!-- <div v-html="courseInfo" class="yuehussdfd"></div> -->
    <div class="fifgj">
      <div class="demo"></div>
      <span class="feihuis" @click="diazan">
        <img src="../../assets/img/zans.png" width="44px"/>
      </span>
    </div>
    <van-action-sheet v-model="showlisy">
      <div class="content">
        <van-row style="
    padding: 15px 10px;
">
          <van-col span="8">
            <van-icon name="cross" @click="showlisy=false"/>
          </van-col>
          <van-col span="8" style="text-align: center;">
            写评论
          </van-col>
          <van-col span="8">
            <span class="hjuisga jinru" @click="fasong">提交</span>
          </van-col>
        </van-row>
        <van-field
          v-model="value"
          rows="5"
          autosize
          ref="inputID"
          type="textarea"
          placeholder="评论被精选后，可被所有人看到"
          show-word-limit
        />
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {
  courseid,
  lessonsetview,
  note,
  notecheckIsExist,
  lessonzan,
  siteurl,
  lessonfeelinglist,
  lessonfeeling,
  declareviewerWatchRecord,
  lessonfeelingid,
  lessonfeelingzan,
  lessonfeelingcancelZan,
  declareintoInsert,
  declarequitUpate,
} from "@/api/home";
import "video.js/dist/video-js.css";
import {videoPlayer} from "vue-video-player";
import "videojs-contrib-hls";
import {Toast} from "vant";

export default {
  data() {
    return {
      playerOptions: {
        live: true,
        autoplay: true,
        notSupportedMessage: "暂时无法播放",
        // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          autoDisable: false,
          progressControl: true,
          fullscreenToggle: true, // 全屏按钮
        },
        poster: require("../../assets/img/kai.png"),
        sources: [
          {
            type: "",
            src: "",
          },
        ],
      },
      // playerOptions: {
      //   live: true,
      //   autoplay: true,
      //   // muted: true,
      //   // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
      //   language: "zh-CN",
      //   aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
      //   fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      //   notSupportedMessage: '',
      //   poster:require("../../assets/img/kai.png"),
      //   controlBar: {
      //     timeDivider: true,
      //     durationDisplay: true,
      //     remainingTimeDisplay: false,
      //     fullscreenToggle: true, // 全屏按钮
      //   },
      //   // type: "video/mp4",
      //   sources: [
      //     {
      //       type: "",
      //       src: "",
      //     },
      //   ],
      // },
      lessonZannum: 0,
      showShare: false,
      show: false,
      courseInfo: "",
      courseViewnum: 0,
      name: 0,
      resList: [],
      lessonVos: "",
      fang: "",
      wxurl: "",
      userName: "",
      lessonId: "",
      netClassCourseVo: {},
      token: localStorage.getItem("token") == '' ? false : localStorage.getItem("token"),
      isHaveRight: "1",
      courseId: "",
      watchOver: 0,
      gklog: 0,
      huix: false,
      noteTime: 0,
      timer: "",
      viewTimer: "",
      roleType: localStorage.getItem("roleType"),
      userId: localStorage.getItem("userId"),
      curPage: 1,
      itemList: [],
      loading: false,
      finished: false,
      total: 0,
      value: "",
      itemLists: [],
      commentsIsOpen: 0,
      guanlist: [],
      loadings: false,
      finisheds: false,
      pageNum: 1,
      spectatorIsOpen: 0,
      lhuid: ''
    };
  },
  watch: {
    lessonId() {
      this.courseid();
    },
    gklog() {
      if (!this.huix) {
        if (this.gklog > 0) {
          this.huix = true;
          this.playerReadied(this.$refs.videoPlayer.player, this.noteTime);
        }
      }
    },
  },
  components: {videoPlayer},
  methods: {
    slice(s, d) {
      return s.slice(10, 16) + " -" + d.slice(10, 16);
    },
    onClick(s) {
      this.name = s;
    },
    courseid() {
      let that = this;
      let params = {
        id: this.lessonId,
      };
      if (this.lessonId == undefined) {
        return false;
      }
      courseid(params)
        .then((res) => {
          that.lessonZannum = res.data.data.lessonZannum;
          that.commentsIsOpen = res.data.data.commentsIsOpen;
          that.spectatorIsOpen = res.data.data.spectatorIsOpen;
          document.title = res.data.data.netClassCourseVo.courseName;
          that.isHaveRight = res.data.data.isHaveRight;
          that.courseViewnum = res.data.data.netClassCourseVo.courseViewnum;
          that.userName = res.data.data.userName;
          that.lessonVos = res.data.data.netClassCourseVo.lessonVos;
          that.resList = res.data.data.netClassCourseVo.resList;
          that.netClassCourseVo = res.data.data.netClassCourseVo;
          that.courseId = res.data.data.courseId;
          if (that.isHaveRight == 1) {
            that.playerOptions.sources[0].type = "video/mp4";
            that.playerOptions.sources[0].src = res.data.data.fileModel.fileUrl;
            that.declareintoInsert();
            clearInterval(that.viewTimer);
            that.viewTimer = setInterval(() => {
              that.declarequitUpate();
            }, 60000);
            if (that.token) {
              clearInterval(that.timer);
              that.timer = setInterval(() => {
                that.note();
              }, 300000);
              that.notecheckIsExist();
            }
          }
          if (that.name == 0) {
            if (that.netClassCourseVo.courseInfo) {
              that.name = 0;
            } else {
              that.name = 1;
            }
          }
          that.show = true;
          that.hui = true;
          that.$refs.videoPlayer.player.play();
          that.lessonsetview();
        })
        .catch(() => {
        });
    },
    dianbo(s) {
      this.lessonId = s;
    },
    onPlayerPlay(player) {
      player.play();
    },
    diazan() {
      let that = this;
      let params = {
        lessonId: this.lessonId,
      };
      lessonzan(params)
        .then((res) => {
          // Toast('点赞成功！')
          var x = 100;
          var y = 100;
          var num = Math.floor(Math.random() * 3 + 1);
          var index = $(".demo").children(".imgsd").length;
          var rand = parseInt(Math.random() * (x - y + 1) + y);

          $(".demo").append("<img src='' class='imgsd'>");
          $(".imgsd:eq(" + index + ")").attr(
            "src",
            // "http://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/u3hSihW5jk.png"
            "https://file.welaiedu.cn/Icon/zan.png"
          );
          $(".imgsd").animate(
            {
              bottom: "600px",
              opacity: "0",
              left: rand,
            },
            3000
          );
          that.lessonZannum++;
        })
        .catch(() => {
        });
    },
    log() {
      // this.$router.push({
      //   path: "/log",
      // });
      let local = siteurl + "#/log?id=" + this.$route.query.id;
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx29b2bf8c2c033c0d&redirect_uri=" +
        encodeURIComponent(local) +
        "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect";
    },
    onPlayerTimeupdate(player) {
      this.gklog = player.cache_.currentTime;
    },
    playerReadied(player, vul) {
      player.currentTime(vul);
    },
    onPlayerEnded(player) {
      this.playerOptions.controlBar.progressControl = true;
      this.watchOver = 1;
    },
    onPlayerPause(player) {
      // player.play();
      // player.pause();
    },
    note() {
      let that = this;
      // that.loading = true
      let params = {
        courseId: that.courseId,
        lessonId: that.lessonId,
        noteTime: that.gklog,
        roleType: that.roleType,
        userId: that.userId,
        watchOver: that.watchOver,
      };
      note(params)
        .then((res) => {
          // that.loading = false
        })
        .catch(() => {
          // that.loading = false
        });
    },
    notecheckIsExist() {
      let that = this;
      that.loading = true;
      let params = {
        lessonId: that.lessonId,
      };
      notecheckIsExist(params)
        .then((res) => {
          that.loading = false;
          that.noteTime = res.data.data.noteTime;
          if (res.data.data.watchOver == 1) {
            that.playerOptions.controlBar.progressControl = true;
            that.watchOver = 1;
          }
        })
        .catch(() => {
          that.loading = false;
        });
    },
    hasUsableFlash() {
      var flashObj;
      if (typeof window.ActiveXObject != "undefined") {
        flashObj = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
      } else {
        flashObj = navigator.plugins["Shockwave Flash"];
      }
      return flashObj ? true : false;
    },

    lessonsetview() {
      let that = this;
      that.loading = true;
      let params = {
        lessonId: parseInt(that.lessonId),
      };
      lessonsetview(params)
        .then((res) => {
          // that.loading = false
        })
        .catch(() => {
          // that.loading = false
        });
    },
    lessonfeelinglist() {
      let that = this;
      let params = {
        curPage: this.curPage,
        lessonId: this.lessonId,
        pageSize: 10,
        replyStatus: 1,
      };
      lessonfeelinglist(params)
        .then((res) => {
          that.loading = false;
          let data = res.data.data.dataList;
          that.total = res.data.data.totalCount;
          if (data == null || data.length == 0) {
            that.finished = true;
            return;
          }
          that.itemList = that.itemList.concat(data);
          if (that.itemList.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.loading = false;
        });
    },
    lessonfeelinglists() {
      let that = this;
      if (!localStorage.getItem("userId") || !this.token) {
        return false;
      }
      let params = {
        curPage: 1,
        lessonId: this.lhuid,
        pageSize: 100,
        replyStatus: 0,
        userId: localStorage.getItem("userId"),
      };
      lessonfeelinglist(params)
        .then((res) => {
          that.itemLists = res.data.data.dataList;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    onLoad() {
      this.curPage++;
      this.lessonfeelinglist();
    },
    fasong() {
      let that = this
      if (that.token) {

      } else {
        Toast('登录后才能评论！')
        return false
      }
      if (that.value == '') {
        Toast('请输入内容！')
        return false
      }
      let params = {
        courseId: this.courseId == '' ? this.lessonId : this.courseId,
        lessonId: this.lessonId,
        roleType: that.roleType,
        userId: that.userId,
        feelingContent: that.value,
      };
      that.showlisy = false
      lessonfeeling(params)
        .then((res) => {
          that.lessonfeelinglists()
          var PageId = document.querySelector('#page')
          window.scrollTo({
            top: PageId.offsetTop - 300,
            behavior: 'smooth'
          })
          that.value = ''
          that.showlisy = false
        })
        .catch(() => {

        });
    },
    declareviewerWatchRecord() {
      let that = this;
      if (that.userId == '') {
        return false
      }
      let params = {
        pageNum: that.pageNum,
        lessonId: that.lhuid,
        pageSize: 1000,
      };
      declareviewerWatchRecord(params)
        .then((res) => {
          console.log(res)
          that.loadings = false;
          let data = res.data.data.dataList;
          let total = res.data.data.totalCount;
          if (data == null || data.length == 0) {
            that.finisheds = true;
            return;
          }
          that.guanlist = that.guanlist.concat(data);
          if (that.guanlist.length >= total) {
            that.finisheds = true;
          }

        })
        .catch(() => {
          that.loadings = false;
        });
    },
    onLoads() {
      this.pageNum++;
      this.declareviewerWatchRecord();
    },
    shanchu(s) {
      let that = this;
      let params = {
        id: s.feelingId,
      };
      lessonfeelingid(params)
        .then((res) => {
          that.lessonfeelinglists()
        })
        .catch(() => {
        });
    },
    shifouzai(s) {
      let unm = 0
      for (var i = 0; i < s.length; i++) {
        if (s[i].userId == this.userId) {
          unm = 1
        }
      }
      return unm
    },
    lessonfeelingzan(s, d) {
      let that = this;
      if (!this.token) {
        Toast("登录后才能点赞哦！");
        return false;
      }
      let params = {
        feelingId: s,
      };
      lessonfeelingzan(params)
        .then((res) => {
          let list = {
            userId: that.userId
          }
          that.itemList[d].likeList.push(list)
        })
        .catch(() => {
        });
    },
    lessonfeelingcancelZan(s, d) {
      let that = this;
      if (!this.token) {
        Toast("登录后才能取消点赞哦！");
        return false;
      }
      let params = {
        feelingId: s,
      };
      lessonfeelingcancelZan(params)
        .then((res) => {
          let list = that.itemList[d].likeList
          for (var i = 0; i < list.length; i++) {
            if (list[i].userId == that.userId) {
              list.splice(i, 1);
            }
          }
          that.itemList[d].likeList = list
        })
        .catch(() => {
        });
    },
    declareintoInsert() {
      let that = this;
      let params = {
        lessonId: this.$route.query.id,
        wxOpenid: localStorage.getItem("openid"),
      };
      declareintoInsert(params)
        .then((res) => {
          // that.wxurl=res.data.data
        })
        .catch(() => {
        });
    },
    declarequitUpate() {
      if (this.$route.query.id) {
        let params = {
          lessonId: this.$route.query.id,
          wxOpenid: localStorage.getItem("openid"),
        };
        declarequitUpate(params)
          .then((res) => {
            // that.wxurl=res.data.data
          })
          .catch(() => {
          });
      }
    },
  },
  beforeRouteLeave(to, form, next) {
    clearInterval(this.timer);
    clearInterval(this.viewTimer);
    this.declarequitUpate()
    // clearInterval(this.timer1);
    // this.timer1 = null;
    if (this.isHaveRight == 1) {
      this.note();
    }
    next();
  },
  mounted() {
    this.lessonId = this.$route.query.id;
    this.lhuid = this.$route.query.id;
    this.courseid();
    this.lessonfeelinglists();
    this.lessonfeelinglist();
    // this.declareviewerWatchRecord();
    window.addEventListener("beforeunload", (e) =>
      this.isHaveRight == 1 ? this.note() : ""
    );
    let that = this;
    window.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        that.$refs.videoPlayer.player.pause();
      } else {
        that.$refs.videoPlayer.player.play();
      }
    });
    // this.timer1 = setInterval(() => {
    //   setTimeout(this.declareviewerWatchRecord(), 0);
    // }, 300000);
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/index/video.vue